module.exports = __webpack_public_path__ + "assets/Video.f193ad1f.svg";